document.addEventListener("DOMContentLoaded", function () {
  const styleCartbotPopup = () => {
    const popup = document.querySelector(".cartbot-popup");
    if (popup && !popup.dataset.modified) {
      
      // Style the title with Bebas Neue font
      const title = popup.querySelector(".cartbot-confirmation-title");
      if (title) {
        title.textContent = "15% Service Fee Notice";
        title.style.fontFamily = "'Bebas Neue', sans-serif";
        title.style.fontWeight = "bold";
        title.style.letterSpacing = "1px";
        title.style.textTransform = "uppercase";
      }
      
      const description = popup.querySelector(".cartbot-confirmation-description");
      if (description) {
        description.textContent =
          "A 15% service fee ($14.85) will be added to your cart. This fee supports our staff and is not taxed.";
      }
      
      // Fixed: Use correct selector for accept button
      const acceptBtn = popup.querySelector(".cartbot-confirmation-add-to-cart-button");
      if (acceptBtn) {
        acceptBtn.textContent = "ADD FEE AND CONTINUE";
        acceptBtn.style.backgroundColor = "#000000";
        acceptBtn.style.color = "#ffffff";
        acceptBtn.style.borderRadius = "0";
        acceptBtn.style.fontFamily = "'Bebas Neue', sans-serif";
        acceptBtn.style.fontWeight = "bold";
        acceptBtn.style.letterSpacing = "1px";
        acceptBtn.style.textTransform = "uppercase";
        acceptBtn.style.setProperty('width', 'fit-content', 'important');
      }
      
      const declineBtn = popup.querySelector(".cartbot-confirmation-deny-button");
      if (declineBtn) {
        declineBtn.style.setProperty('display', 'none', 'important');
        declineBtn.style.setProperty('visibility', 'hidden', 'important');
        declineBtn.style.setProperty('opacity', '0', 'important');
        declineBtn.style.setProperty('pointer-events', 'none', 'important');
      }
      
      popup.dataset.modified = "true";
    }
  };
  
  // Add CSS rule dynamically with high specificity
  const addOverrideCSS = () => {
    if (!document.querySelector('#cartbot-decline-override')) {
      const style = document.createElement('style');
      style.id = 'cartbot-decline-override';
      style.textContent = `
        .cartbot-popup .cartbot-confirmation-deny-button,
        .cartbot-confirmation-deny-button,
        [class*="cartbot-confirmation-deny-button"],
        [class*="deny-button"] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
          position: absolute !important;
          left: -9999px !important;
          width: 0 !important;
          height: 0 !important;
          overflow: hidden !important;
          margin: 0 !important;
          padding: 0 !important;
          border: none !important;
        }
        
        /* Additional styling for title */
        .cartbot-confirmation-title,
        .cartbot-popup h2 {
          font-family: 'Bebas Neue', sans-serif !important;
          font-weight: bold !important;
          letter-spacing: 1px !important;
          text-transform: uppercase !important;
        }
        
        /* Hide the products container */
        .cartbot-confirmation-products-container.centered-one-item {
          display: none !important;
        }
        
        /* Remove background from products and button container */
        .cartbot-confirmation-products-and-button-container {
          background: unset !important;
        }
        
        /* Additional button styling */
        .cartbot-confirmation-modal .cartbot-confirmation-add-to-cart-button {
          background-color: #1f1f1f !important;
          font-weight: bold !important;
          text-transform: uppercase !important;
          width: fit-content !important;
          border-radius: unset !important;
        }
      `;
      document.head.appendChild(style);
    }
  };
  
  // Apply the CSS override immediately
  addOverrideCSS();
  
  // Use MutationObserver to catch DOM injections dynamically
  const observer = new MutationObserver(() => {
    styleCartbotPopup();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  
  // Also use polling every 300ms just in case
  const interval = setInterval(() => {
    styleCartbotPopup();
  }, 300);
  
  // Stop polling after 10 seconds
  setTimeout(() => {
    clearInterval(interval);
  }, 10000);
});